const PHRASES = [
  "Every child deserves a healthier beginning",
  "Thoughtful pediatric care",
  "Trusted health education",
  "Preventive pediatrics",
  "Gentle, evidence-based guidance",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {PHRASES.map((p, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display italic text-2xl sm:text-3xl text-[#70435F]/80 px-8 whitespace-nowrap">{p}</span>
        <span className="w-2 h-2 rotate-45 bg-[#B89A69]/70 shrink-0" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-[#E7DED4] bg-[#FAF7F4] py-6 overflow-hidden"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
